// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"356":"43289bb8","592":"0029d239","720":"112ac58a"}[chunkId] + ".chunk.js";
};